import axios from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const baseUrl = getApiBaseUrl();

const ensureBaseUrl = () => {
  if (!baseUrl) {
    throw new Error("REACT_APP_API_BASE_URL is not configured");
  }

  return baseUrl;
};

export const listRequestTypes = async ({ includeInactive = true } = {}) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/requests/types`, {
    params: { includeInactive },
  });

  return response?.data || {};
};

export const createRequestType = async (payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/requests/types`, payload);
  return response?.data || {};
};

export const updateRequestType = async (id, payload) => {
  const response = await axios.patch(`${ensureBaseUrl()}/organizations/requests/types/${id}`, payload);
  return response?.data || {};
};

export const deleteRequestType = async (id) => {
  const response = await axios.delete(`${ensureBaseUrl()}/organizations/requests/types/${id}`);
  return response?.data || {};
};

export const listRequestApplications = async (params = {}) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/requests/applications`, { params });
  return response?.data || {};
};

export const getLeaveAvailability = async ({ upcomingDays = 14 } = {}) => {
  const response = await axios.get(
    `${ensureBaseUrl()}/organizations/requests/leave-availability`,
    { params: { upcomingDays } },
  );
  return response?.data || {};
};

export const submitRequestApplication = async (payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/requests/applications`, payload);
  return response?.data || {};
};

export const getRequestApplicationById = async (id) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/requests/applications/${id}`);
  return response?.data || {};
};

export const decideRequestApplication = async (id, payload) => {
  const response = await axios.patch(
    `${ensureBaseUrl()}/organizations/requests/applications/${id}/decision`,
    payload
  );
  return response?.data || {};
};

export const getRequestTypeAnalytics = async (requestTypeId) => {
  const response = await axios.get(
    `${ensureBaseUrl()}/organizations/requests/types/${requestTypeId}/analytics`
  );
  return response?.data || {};
};

export const updateRequestApplication = async (id, payload) => {
  const response = await axios.patch(`${ensureBaseUrl()}/organizations/requests/applications/${id}`, payload);
  return response?.data || {};
};

export const listRequestApproverPositions = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/positions`);
  return response?.data?.positions || [];
};

export const listRequestRelievers = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/requests/relievers`);
  return response?.data?.relievers || [];
};
